import React from "react";
import "./styles.css";
import { Formik, Form, useField } from "formik";
import Error from "../Error/index.js";

const FormInput = ({ CSSClass = "inputBox", label, ...props }) => {
  // useField() returns [formik.getFieldProps(), formik.getFieldMeta()]
  // which we can spread on <input>. We can use field meta to show an error
  // message if the field is invalid and it has been touched (i.e. visited)
  const [field, meta] = useField(props);
  return (
    <div className="field">
      <label htmlFor={props.name} className="label">
        {label}
      </label>
      <input className={CSSClass} {...field} {...props} />
      {meta.touched ? (
        <Error msg={meta.error} />
      ) : (
        <div className="error"></div>
      )}
    </div>
  );
};
export default FormInput;
